import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyBAOXnskyzpWHmSfzIC6xyRBV_dlbEtgcY",
  authDomain: "lida-gallery-f9dc3.firebaseapp.com",
  projectId: "lida-gallery-f9dc3",
  storageBucket: "lida-gallery-f9dc3.firebasestorage.app",
  messagingSenderId: "712810157544",
  appId: "1:712810157544:web:89abc0fcababceac8d405d",
  measurementId: "G-0HQHBB20NK"
};

// Initialize Firebase
let app = null;
let analytics = null;
let db = null;

try {
  app = initializeApp(firebaseConfig);
  
  // Initialize Analytics only in browser
  if (typeof window !== 'undefined') {
    try {
      analytics = getAnalytics(app);
    } catch (error) {
      console.warn('Analytics initialization failed:', error);
    }
  }
  
  // Initialize Firestore
  db = getFirestore(app);
} catch (error) {
  console.error('Firebase initialization error:', error);
}

export { app, analytics, db };

